'use strict'

// Displays the terms of use link. Link text and url are localized
cpntMap.set('awe-termsofuse', {
  props: {
    visible: { type: Boolean, default: true },
    wtbid: String,
    touchPoint: String
  },
  data: function() {
    return {
      i18n: this.$root.i18n,
      defaultUrl: 'https://www.mikmak.com/legal/privacypolicy'
    }
  },
  computed:{
    policyUrl: function() {
      const url = i18n.getString('PRIVACY_POLICY_URL', null, null, this.defaultUrl)
      let qs = ''
      if ((this.touchPoint || this.$root.wtbConf.touchPoint) && (this.wtbid || this.$root.wtbid))
        qs = `utm_source=pop&utm_medium=${(this.touchPoint || this.$root.wtbConf.touchPoint).toLowerCase()}&utm_campaign=${this.wtbid || this.$root.wtbid}`

      return url + (url.includes('?') ? '&' : '?') + qs
    }
  },
  template: `
    <a class="termsofuse" v-if="visible" :href="policyUrl" target="_blank" :title="i18n.getString('TERMSOFUSE')">
      <slot>{{ i18n.getString('TERMSOFUSE') }}</slot>
    </a>
  `
})
